import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

/**
 * 販売受付設定のチケット
 * @example
 * <div data-controller="reception-tickets">
 *   <div data-reception-tickets-target="masterTicket">
 *    マスターチケット
 *    <button data-action="reception-tickets#remove">まとめて解除</button>
 *    <div data-reception-tickets-target="ticket">
 *      チケット
 *     <button data-action="reception-tickets#remove">解除</button>
 *    </div>
 */
export class ReceptionTicketsController extends Controller {
  static targets = ["ticket", "masterTicket"];
  static values = { effect: { type: String, default: "slide" } };
  static outlets = ["add-tickets"];

  #isMasterRemoved = false;
  #removedTickets = [];

  connect() {
    this.#update();
  }

  remove(e) {
    // console.debug("remove", e);
    const ticketTarget = this.ticketTargets.find((ticket) => ticket.contains(e.currentTarget));
    if (ticketTarget) {
      this.#removedTickets.push(ticketTarget);
      // 全てのチケットが解除された場合はマスターチケットも解除する
      if (this.ticketTargets.length === this.#removedTickets.length) {
        this.#isMasterRemoved = true;
      }
    } else if (this.masterTicketTarget.contains(e.currentTarget)) {
      this.#isMasterRemoved = true;
    }

    this.#update();
  }

  #update() {
    // console.debug("update", this.#isMasterRemoved, this.#removedTickets);

    // マスターチケットの表示を更新する
    if (this.effectValue === "slide") {
      this.#isMasterRemoved ? $(this.masterTicketTarget).slideUp() : $(this.masterTicketTarget).slideDown();
    }
    // チケットの表示を更新する
    for (const target of this.ticketTargets) {
      const removed = this.#isMasterRemoved || this.#removedTickets.includes(target);
      if (this.effectValue === "slide") {
        removed ? $(target).slideUp() : $(target).slideDown();
      }
      // inputのdisabledを更新する
      for (const input of target.querySelectorAll("input")) {
        input.disabled = removed;
        // 販売チケット追加ドロワーにお伝えする
        if (this.hasAddTicketsOutlet && removed) {
          this.addTicketsOutlet.enable(input.value);
        }
      }
    }
  }
}

/**
 * 販売チケット追加ドロワー
 */
export class AddTicketsController extends Controller {
  static targets = ["checkbox"];

  /**
   * チェックボックスを有効にする
   */
  enable(value) {
    const checkbox = this.checkboxTargets.find((checkbox) => checkbox.value === value);
    // console.debug("enable", value, checkbox);
    if (!checkbox || !checkbox.disabled) {
      return;
    }
    checkbox.disabled = false;
    checkbox.checked = false;
    const card = checkbox.closest(".ticket-card");
    if (card) card.ariaDisabled = false;
  }
}
